var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.26134 1.77594C7.53462 1.11891 8.46538 1.11891 8.73866 1.77594L9.92838 4.63637C10.0436 4.91336 10.3041 5.10261 10.6031 5.12659L13.6912 5.37416C14.4005 5.43102 14.6881 6.31623 14.1477 6.77916L11.7949 8.79457C11.5671 8.98974 11.4676 9.29596 11.5372 9.58776L12.256 12.6012C12.4211 13.2934 11.6681 13.8405 11.0608 13.4695L8.417 11.8547C8.16099 11.6983 7.83901 11.6983 7.583 11.8547L4.93918 13.4695C4.3319 13.8405 3.5789 13.2934 3.74401 12.6012L4.46282 9.58776C4.53243 9.29596 4.43293 8.98974 4.2051 8.79457L1.85231 6.77917C1.31188 6.31623 1.5995 5.43102 2.30883 5.37416L5.3969 5.12659C5.69593 5.10261 5.95642 4.91336 6.07162 4.63637L7.26134 1.77594Z",
    fill: "#FFD234"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarYellow);
export default __webpack_public_path__ + "static/media/star-yellow.29adfe40619990dd1db7c2c673f799eb.svg";
export { ForwardRef as ReactComponent };